import React, { useEffect, useRef } from 'react'
import Talk from 'talkjs'

import SingleChatView from '../component/SingleChatView'
import { CONFIG } from '../../../../Config/config'
import { notificationHandler } from '../../utils'
import { getUnreadStatuses } from '../../api'

const { appID } = CONFIG.TALKJS

const ClientsChat = ({
  user,
  showOnlyUnread,
  setNotificationConversation,
  setViewType,
  conversationId,
}) => {
  let ref = useRef(null)

  const initChat = async ({ ref, userId, conversationId }) => {
    await Talk.ready

    const me = new Talk.User(userId)
    const session = new Talk.Session({
      appId: appID,
      me,
    })
    const conversation = conversationId
      ? session.getOrCreateConversation(conversationId)
      : null

    const inbox = session.createInbox({ theme: 'oads' })

    session.unreads.onChange(async () => {
      await getUnreadStatuses()
    })

    const filterOptions = showOnlyUnread
      ? {
          hasUnreadMessages: true,
          custom: { isClientChat: 'exists' },
        }
      : {
          custom: { isClientChat: 'exists' },
        }
    inbox.setFeedFilter(filterOptions)

    session.onDesktopNotificationClicked(data => {
      setNotificationConversation(data.conversation.id)
      notificationHandler({ data, inbox, session, setViewType })
    })

    if (conversation) {
      inbox.select(conversation)
    }

    inbox.mount(ref)
  }

  useEffect(() => {
    if (user.id) {
      initChat({
        ref,
        userId: user.id,
        conversationId,
      })
    }
  }, [user.id, showOnlyUnread, conversationId])

  const setRef = value => {
    ref = value
  }

  return <SingleChatView setRef={setRef} height="calc(100vh - 140px)" />
}

export default ClientsChat
